import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI, { size: 'small' })
Vue.config.productionTip = false

// 统一兜底：渲染稳定后 debounce 触发 el-table doLayout 重测布局（gutter、行高、列宽）
Vue.mixin({
  updated() {
    if (!this.$el || !this.$el.querySelectorAll) return
    clearTimeout(this.$__tblLayoutTimer)
    this.$__tblLayoutTimer = setTimeout(() => {
      this.$el.querySelectorAll('.el-table').forEach(el => {
        const vm = el.__vue__
        if (vm && vm.doLayout) vm.doLayout()
      })
    }, 150)
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
